import React from "react"

const Dollar = ({ width = "52", height = "68", viewBox = "0 0 52 68" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-dollar-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.997 39.858c-.1-3.533-2.3-6.563-5.534-7.583l-7.284-2.295c-.942-.3-1.542-1.23-1.456-2.28.1-1.125 1.07-1.95 2.142-1.95h4.277c1.079 0 2.071.36 2.892.968.871.652 2.05.592 2.807-.203l1.014-1.065c.906-.953.828-2.543-.186-3.367a10.434 10.434 0 0 0-5.813-2.303v-1.53c0-1.245-.957-2.25-2.142-2.25h-1.428c-1.185 0-2.142 1.005-2.142 2.25v1.56c-4 .465-7.255 4.035-7.141 8.332.1 3.533 2.3 6.563 5.534 7.583l7.284 2.295c1.128.352 1.806 1.702 1.285 2.947-.336.803-1.135 1.283-1.978 1.283h-4.27c-1.079 0-2.071-.36-2.892-.968-.871-.652-2.05-.592-2.807.203l-1.014 1.065c-.906.953-.828 2.543.193 3.367a10.318 10.318 0 0 0 5.806 2.303v1.53c0 1.245.957 2.25 2.142 2.25h1.428c1.185 0 2.142-1.005 2.142-2.25v-1.553c4-.472 7.255-4.042 7.141-8.34Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-dollar-icon"
          x="-14"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Dollar
